import React from 'react'

const InterviewPractice = () => {
  return (
    <div>
    <h1>what are practice questions?</h1>
    <hr />
    <p>As you have read in the Interview Guide for beginners, you will have live coding round. These are a few questions you can practice for the round and feel confident about.</p>
    <hr />
    <h1>sample questions</h1>
    <hr />
    <p>Interviews are generally 15-20 minutes long only. Here's how it will go.</p>

    <ol>
        <li>Sample Q1
            <ul>
                <li>Create a web app that would take two inputs. It would also have 4 buttons: +, -, x /. Based on the button clicked perform the operation on the two inputs. You can do this in React or vanillaJS based on your choice. Your time starts now.</li>
                <li>See, you have 15 minutes to code this question. Questions are simple. We want to test whether:</li>
            </ul>
        </li>
        <li>Sample Q2
            <ul>
                <li>Create a web app where I can input a text. Now create two buttons + and -. On clicking + increase the fontSize by 2px and vice versa.</li>
            </ul>
        </li>
        <li>Sample Q3
            <ul>
                <li>Create a web app where I can input a text. Now, create three buttons h1, h2, h3. When I click on any of the button, the text should become h1, h2, or h3.</li>
            </ul>
        </li>
        <li>Sample Q4
            <ul>
                <li>Create a web app where I can input a text. Now, create three buttons: red, green, blue. Clicking on the button should change the text color.</li>
            </ul>
        </li>
        <li>Sample Q5
            <ul>
                <li>Create a CLI app which takes name, unit test marks, pre final marks, final marks of 5 students. And then print who has the highest marks. What if I ask you to print the average as well?</li>
            </ul>
        </li>
        <li>Sample Q6
            <ul>
                <li>Create a web app with a button loded. Show a text loading... on a web app. However, hide it if I click on the button loaded.</li>
            </ul>
        </li>
        <li>Sample Q7
            <ul>
                <li>Create a web app where I can input a text. Now create two buttons + and -. On clicking + increase the fontSize by 2px and vice versa.</li>
            </ul>
        </li>
        <li>Sample Q8
            <ul>
                <li>Create a web app where I can input a text. Now, create three buttons h1, h2, h3. When I click on any of the button, the text should become h1, h2, or h3.</li>
            </ul>
        </li>
        <li>Sample Q9
            <ul>
                <li>Create a web app where I can input a text. Now, create three buttons: red, green, blue. Clicking on the button should change the text color.</li>
            </ul>
        </li>
        <li>Sample Q10
            <ul>
                <li>Create a CLI app which takes name, unit test marks, pre final marks, final marks of 5 students. And then print who has the highest marks. What if I ask you to print the average as well?</li>
            </ul>
        </li>
        <li>Sample Q11
            <ul>
                <li>Create a web app with a button loded. Show a text loading... on a web app. However, hide it if I click on the button loaded.</li>
            </ul>
        </li>
    </ol>
</div>
  )
}

export default InterviewPractice